import { SortOrder } from "@/generated/graphql";
import { ITEM_LIMIT } from "@/lib/constants/shared";

export interface LessonsByParentOptions {
  parentId: string | null;
  searchText?: string | null | undefined;
  sortBy?: SortOrder | undefined;
  isTrash?: boolean | undefined;
  skip?: boolean | undefined;
}

export const getLessonsByParentIdVars = ({
  parentId,
  searchText,
  sortBy = SortOrder.Recent,
  isTrash = false,
}: LessonsByParentOptions) => {
  return {
    parentId,
    limit: isTrash ? 100 : ITEM_LIMIT.generalItemLimit,
    offset: 0,
    searchText: searchText || null,
    sortBy,
    isTrash,
  };
};
